import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=672fb8f9&scoped=true&"
import script from "./Setup.vue?vue&type=script&lang=js&"
export * from "./Setup.vue?vue&type=script&lang=js&"
import style0 from "./Setup.vue?vue&type=style&index=0&id=672fb8f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672fb8f9",
  null
  
)

export default component.exports